import { ITlfActionToggleTrafficLights, TlfContextProps } from "./interface";

/**
 * Updates whether traffic lights are visible for the active TLF.
 *
 * @param state - Current TLF context state.
 * @param action - Toggle-traffic-lights action containing the next visibility flag.
 * @returns Updated state with traffic light visibility changed.
 */
export const tlf_toggleTrafficLights = (
  state: TlfContextProps,
  action: ITlfActionToggleTrafficLights,
): TlfContextProps => ({
  ...state,
  showTrafficLights: action.showTrafficLights,
});
